import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { ComponentSettingsVariables } from "@intelligems/ig-widgets/ProgressBarView/util/textVariables";
import { Grid } from "@mui/material";
import { VariableTextInput } from "@src/features/personalizations/components/offerModifications/userInterfaces/VariableTextInput";

interface RichTextInputProps {
  label?: string;
  value?: string | null;
  placeholder?: string;
  variables?: ComponentSettingsVariables[];
  limit?: number;
  onChange: (value: string) => void;
}

export const BaseTextInput = ({
  label,
  value,
  placeholder,
  variables,
  limit,
  onChange,
}: RichTextInputProps) => {
  return (
    <Grid item container direction={"column"} rowSpacing={2}>
      <Grid item>
        <IgTypography>{label ?? ""}</IgTypography>
      </Grid>

      <Grid item xs={12}>
        <VariableTextInput
          value={value ?? ""}
          limit={limit}
          variables={variables}
          onChange={onChange}
          placeholder={placeholder}
        />
      </Grid>
    </Grid>
  );
};
